import { AdminBlockAttributeInputType, AdminBlockTypeAttribute } from '@headlines/types/block/adminBlockType';

const slidesPerBreakpoint: AdminBlockTypeAttribute = {
  label: 'Carousel slides per breakpoint (small,medium,large)',
  key: 'slidesPerBreakpoint',
  inputType: AdminBlockAttributeInputType.STRING_INPUT,
};

export default slidesPerBreakpoint;
